import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './managefaqform.css';
import HttpClient from "../utils/HttpClient";
import { toast } from 'react-hot-toast';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

const ItemView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const item = location.state;
    const isEdit = location.state ? true : false;
    const [itemName, setItemName] = useState(item ? item.itemName : '');
    const [selectedOption, setSelectedOption] = useState(null);
    console.log("s54df1", item)

    // >>>>Select Graph Option<<<<
    const options = [
        { value: 'pie', label: 'Pie' },
        { value: 'bar', label: 'Bar-Graph' },
        { value: 'line', label: 'Line-Graph' },
        { value: 'table', label: 'Table' },
    ];

    // Initialize the selected option based on item.type
    useEffect(() => {
        if (item && item.type) {
            const defaultOption = options.find(option => option.value === item.type);
            setSelectedOption(defaultOption);
        }
    }, [item, options]);

    // >>>>Handle Select Change<<<<
    const handleChange = (option) => {
        setSelectedOption(option);
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!itemName.trim()) {
            toast.error('Please enter an item name');
            return;
        }

        if (!selectedOption) {
            return toast.error("Please select a graph type...!")
        }

        try {
            const data = {
                itemName,
                type: selectedOption?.value
            }
            console.log("datasgd545", data)
            let res;
            // return
            if (isEdit) {
                // Edit API request
                res = await HttpClient.requestData(`project-item/${item._id}`, "PUT", data);
                console.log("Edit Response:", res);
                if (res && res.status) {
                    toast.success('Project item updated successfully');
                    navigate('/manageprojectitems');
                } else {
                    toast.error('Failed to update project item');
                }
            } else {
                // Add API request
                res = await HttpClient.requestData("project-item", "POST", data);
                console.log("Add Response:", res);
                if (res && res.status) {
                    toast.success('Project item added successfully');
                    navigate('/manageprojectitems');
                } else {
                    toast.error('Failed to add project item');
                }
            }

            // Navigate back after submission
        } catch (error) {
            console.error("API Request Error:", error);
            toast.error('An error occurred. Please try again later.');
        }
    };

    return (
        <div className='faqFormContainer' style={{ marginLeft: "350px" }}>
            <div className='header'>
                <b style={{ fontSize: "20px", fontWeight: "400" }}>{isEdit ? "Edit Item" : "Add Item"}</b>
                <b className='back' style={{ color: "rgb(212, 52, 52)" }} onClick={handleBackClick}>
                    <i className="fas fa-arrow-left" style={{ marginRight: '8px', }}></i>
                    Back
                </b>
            </div>

            <form className='faqForm' onSubmit={handleSubmit}>
                <div className='formGroup'>
                    <label htmlFor="itemName">Item Name</label><br />
                    <input
                        type="text"
                        id="itemName"
                        placeholder="Name"
                        value={itemName}
                        onChange={(e) => setItemName(e.target.value)}
                    />
                </div>
                <div className='formGroup'>
                    <Select
                        value={selectedOption}
                        onChange={handleChange}
                        options={options}
                        placeholder="Select a graph type..."
                    />
                </div>
                <button type="submit" className='saveButton' style={{ backgroundColor: "red" }}>
                    {isEdit ? "Edit" : "Save"}
                </button>

            </form>

            <footer style={{ position: "fixed", bottom: "0", width: "100%", padding: "10px 0", zIndex: "1", backgroundColor: "#fff" }}>
                <p style={{ fontSize: "12px", color: "#666" }}>Copyright © 2024 Psedge. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default ItemView;
